import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionsListPage } from '@/modules/subscriptions/pages/SubscriptionsListPage';

export const Route = createFileRoute('/dashboard/subscriptions/')({
  component: SubscriptionsListPage,
});
